<template>
  <div>
    <c-card
      class="ope-card--closed"
      v-for="sr in supportReviews"
      :key="sr.id"
      :item="sr"
      :id="'support_review' + sr.id"
      :button-title="buttonTitle(sr.support_rating)">
      <div class="col-auto" slot="header">
        <p>
          <span class="badge badge-primary font-size-normal mb-1 mr-2">#{{ sr.support_request.id }}</span>
          <span class="badge font-size-normal" :class="'badge-' + sr.support_request.status.badge">
            {{ sr.support_request.status.title }}
          </span>
        </p>
        <p class="mb-0">Créée pour <span class="h5 thin">{{ sr.support_request.product.name }}
        <small class="bg-dark text-white px-2" v-if="sr.support_request.product.type">
          {{ sr.support_request.product.type }}
        </small></span></p>
        <p class="text-secondary thin mb-0">le {{ sr.formatted_created_at }}</p>
      </div>
      <div slot="body" class="l-spaced mb-n3">
        <section>
          <h3 class="h6 mb-3">1- Prise en charge et accompagnement</h3>
          <div class="smaller">
            <p>
              Note sur l'intervention :
              <span class="rating-display rating-display--5stars ml-h">
                <span class="rating-display__rating rating-display--5stars__rating" :style="'width:' + sr.support_rating * 20 +'%;'"></span>
              </span>
            </p>
            <p>Prise en charge du problème : <span class="thin">{{ sr.problem_analyzed | notSpecified }}</span></p>
            <p v-if="sr.problem_analyze_comment">
              Commentaire : <span class="thin">{{ sr.problem_analyze_comment }}</span>
            </p>
          </div>
        </section>
        <section class="mt-4">
          <h3 class="h6 mb-3">2- Résolution du problème</h3>
          <div class="smaller">
            <p>Le problème a été résolu : <span class="thin">{{ sr.problem_solved | notSpecified }}</span></p>
            <p v-if="sr.problem_solved_comment">
              Commentaire : <span class="thin">{{ sr.problem_solved_comment }}</span>
            </p>
          </div>
        </section>
        <section class="mt-4">
          <h3 class="h6 mb-3">3- Note globale</h3>
          <div class="smaller">
            <p>
              Note Bestove :
              <span class="rating-display rating-display--10stars ml-h">
                <span class="rating-display__rating rating-display--10stars__rating" :style="'width:' + sr.bestove_rating * 10 +'%;'"></span>
              </span>
            </p>
            <p v-if="sr.bestove_comment">
              Commentaire sur Bestove : <span class="thin">{{ sr.bestove_comment }}</span>
            </p>
          </div>
        </section>
      </div>
    </c-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SupportReviews',
  computed: {
    ...mapGetters({ supportReviews: 'bestove/supportReviews' })
  },
  methods: {
    buttonTitle (rate) {
      return `Voir l'avis ${rate}/5`
    }
  }
}
</script>
